import type { TokenName } from '~/lib/theme-colors';

/** Series are coloured by what they are, in this order (DESIGN.md §8.1). */
export const CHART_SERIES_TOKENS: TokenName[] = [
  'brand-500',
  'theme-purple-500',
  'theme-pink-500',
  'blue-light-500',
  'orange-500',
];

export const CHART_MARGIN = { top: 20, right: 20, bottom: 30, left: 60 };
export const CHART_AXIS = { tickSize: 5, tickPadding: 5, tickRotation: 0 };
